import { CpgManufacturerProgramFragment } from '@occc/graphql';

import { RetailerNetworkTobaccoOffersSectionController } from './retailer-network-tobacco-offers-section.controller';

type RetailerNetworkTobaccoPerformanceManufacturersProps = {
  manufacturerPrograms?: CpgManufacturerProgramFragment[];
  retailerNetworkUuid: string;
  startDate: Date;
  endDate: Date;
};

export const RetailerNetworkTobaccoPerformanceManufacturers = ({
  manufacturerPrograms,
  retailerNetworkUuid,
  startDate,
  endDate,
}: RetailerNetworkTobaccoPerformanceManufacturersProps) => {
  return manufacturerPrograms?.map((item, index) => (
    <RetailerNetworkTobaccoOffersSectionController
      key={item.id}
      manufacturerProgramId={item.id}
      retailerNetworkUuid={retailerNetworkUuid}
      startDate={startDate}
      endDate={endDate}
      title={item.name}
      isExpanded={index === 0}
    />
  ));
};
